module.exports = {
  /* 01.General */
  "chat.end":"チャットの会話を再開する",
  "chat.endall":"チャットを終了する",
  "chat.cancel":"キャンセル",
  "chat.cookie":"このデジタルアシスタントはCookieを使用して、最高のエクスペリエンスを提供します",
  "chat.learn":"もっと詳しく知る",
  "chat.minimize":"最小化",
  "chat.hide":"近い",
  "chat.hidebot.text":"閉じるとアバターが 15 分間消えます",
  "chat.hidebot":"ボットを閉じる",
  "chat.restart":"再起動",
  "switch.language":"言語の切り替え",
  "switch.property":"スイッチプロパティ",
  "restart.converstation":"会話を再開する",
  "chat.endtext":"現在のチャットを終了してもよろしいですか?",
  "check.availabity":"空室状況を確認する",
  "check.availabity.submit":"送信",
  "check.availabity.cancel":"キャンセル",
  "check.availabity.adults":"大人 (13+)",
  "check.availabity.children":"子供",
  "check.availabity.child.age":"年齢 - 子",
  "feedback.leave":"フィードバックを残す",
  "feedback.leave.message":"メッセージを残す",
};
